/*
 * Workaround for Bulk Discounts Now: an applied discount code can't be removed.
 *
 * Shopify cart tokens now carry a "?key=..." suffix. BDN concatenates the token
 * straight into its removal URL, so the "?" starts a query string and only the
 * part before it survives as the path segment -- but BDN stores and matches on
 * the whole token, so the lookup misses and the server answers
 * {"deleted_discounted_cart": false}. BDN's success handler has no else branch:
 *
 *     success: function(n){ if (n.deleted_discounted_cart) { ...update UI... } }
 *
 * so the click does nothing and the customer is never told why.
 *
 * Percent-encoding keeps the token in a single path segment and the removal
 * succeeds. Verified against the live store: raw token -> false and the code
 * survives; encoded token -> true and the code is gone.
 */
(function () {
  'use strict';

  var BDN_FALLBACK_HOST = 'https://app.bulkdiscountsnow.com';
  var TAG = '.qb-discount-code-tag';

  function bdnHost() {
    if (window.qb && window.qb.serverAddress) return window.qb.serverAddress;
    return BDN_FALLBACK_HOST;
  }

  function removeAppliedCode() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.token) return false;
        // encodeURIComponent is the entire fix: it keeps "?key=" inside the path.
        return fetch(bdnHost() + '/cart/remove_discount_code/' + encodeURIComponent(cart.token))
          .then(function (r) { return r.json(); })
          .then(function (j) { return !!(j && j.deleted_discounted_cart); });
      });
  }

  // BDN binds its own handler with $(document).on("click", ...) in the bubble
  // phase, so capturing here runs first and stops the broken request going out.
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var tag = e.target.closest(TAG);
    if (!tag) return;
    if (!tag.textContent || !tag.textContent.trim()) return; // no code applied

    e.preventDefault();
    e.stopImmediatePropagation();
    tag.style.pointerEvents = 'none';

    removeAppliedCode().then(function (removed) {
      if (removed) {
        if (window.qb && window.qb.datastore) window.qb.datastore.discount_codes = [];
        // Reload so totals, the wrapper and the input all return to a clean state.
        window.location.reload();
      } else {
        tag.style.pointerEvents = '';
        console.warn('Discount code could not be removed.');
      }
    }, function () {
      tag.style.pointerEvents = '';
      console.warn('Discount code removal request failed.');
    });
  }, true);
})();
